import React, { useState } from 'react';
import { Plane, Lock, User, ArrowRight, Building } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
export function InviteAcceptPage() {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    // Simulate API call
    setTimeout(() => {
      setIsLoading(false);
      navigate('/login');
    }, 1500);
  };
  return <div className="min-h-screen w-full flex items-center justify-center bg-slate-900 relative overflow-hidden" data-id="element-884">
      <div className="absolute inset-0 bg-[linear-gradient(to_right,#80808012_1px,transparent_1px),linear-gradient(to_bottom,#80808012_1px,transparent_1px)] bg-[size:24px_24px]" data-id="element-885"></div>

      <div className="relative w-full max-w-md p-6" data-id="element-886">
        <div className="mb-8 text-center" data-id="element-887">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-2xl bg-blue-600 text-white shadow-xl shadow-blue-500/20" data-id="element-888">
            <Plane className="h-8 w-8" data-id="element-889" />
          </div>
          <h1 className="text-2xl font-bold text-white" data-id="element-890">Join Acme Corp</h1>
          <p className="mt-2 text-slate-400" data-id="element-891">
            You've been invited to join TravelHub
          </p>
        </div>

        <div className="rounded-2xl bg-white p-8 shadow-2xl" data-id="element-892">
          <form onSubmit={handleSubmit} className="space-y-5" data-id="element-893">
            <div data-id="element-894">
              <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-895">
                Organization
              </label>
              <div className="relative" data-id="element-896">
                <Building className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-897" />
                <input type="text" disabled value="Acme Corp" className="block w-full rounded-lg border border-slate-200 bg-slate-50 pl-10 p-2.5 text-slate-500" data-id="element-898" />
              </div>
            </div>

            <div data-id="element-899">
              <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-900">
                Email Address
              </label>
              <input type="email" disabled value="sarah.connor@acme.com" className="block w-full rounded-lg border border-slate-200 bg-slate-50 p-2.5 text-slate-500" data-id="element-901" />
            </div>

            <div data-id="element-902">
              <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-903">
                Full Name
              </label>
              <div className="relative" data-id="element-904">
                <User className="absolute left-3 top-1/2 h-5 w-5 -translate-y-1/2 text-slate-400" data-id="element-905" />
                <input type="text" required className="block w-full rounded-lg border border-slate-300 pl-10 p-2.5 focus:border-blue-500 focus:ring-blue-500" placeholder="Sarah Connor" data-id="element-906" />
              </div>
            </div>

            <div data-id="element-907">
              <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-908">
                Department
              </label>
              <select className="block w-full rounded-lg border border-slate-300 p-2.5 focus:border-blue-500 focus:ring-blue-500" data-id="element-909">
                <option data-id="element-910">Engineering</option>
                <option data-id="element-911">Sales</option>
                <option data-id="element-912">Marketing</option>
                <option data-id="element-913">Operations</option>
                <option data-id="element-914">HR</option>
              </select>
            </div>

            <div className="grid grid-cols-2 gap-4" data-id="element-915">
              <div data-id="element-916">
                <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-917">
                  Password
                </label>
                <div className="relative" data-id="element-918">
                  <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-919" />
                  <input type="password" required className="block w-full rounded-lg border border-slate-300 pl-9 p-2.5 text-sm focus:border-blue-500 focus:ring-blue-500" placeholder="••••••••" data-id="element-920" />
                </div>
              </div>
              <div data-id="element-921">
                <label className="mb-1.5 block text-sm font-medium text-slate-700" data-id="element-922">
                  Confirm
                </label>
                <div className="relative" data-id="element-923">
                  <Lock className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" data-id="element-924" />
                  <input type="password" required className="block w-full rounded-lg border border-slate-300 pl-9 p-2.5 text-sm focus:border-blue-500 focus:ring-blue-500" placeholder="••••••••" data-id="element-925" />
                </div>
              </div>
            </div>

            <button type="submit" disabled={isLoading} className="flex w-full items-center justify-center rounded-lg bg-blue-600 px-5 py-2.5 text-center text-sm font-medium text-white hover:bg-blue-700 focus:outline-none focus:ring-4 focus:ring-blue-300 disabled:opacity-70" data-id="element-926">
              {isLoading ? 'Setting up account...' : 'Accept Invitation'}
              {!isLoading && <ArrowRight className="ml-2 h-4 w-4" data-id="element-927" />}
            </button>
          </form>
        </div>

        <p className="mt-6 text-center text-sm text-slate-500" data-id="element-928">
          Not you?{' '}
          <Link to="/login" className="font-medium text-blue-400 hover:underline" data-id="element-929">
            Sign in to a different account
          </Link>
        </p>
      </div>
    </div>;
}